<template>
  <div>
    <a-form-model :form="filterForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :model="filterForm" class="search-form">
      <a-row :gutter="4">
        <a-col :span="6">
          <a-form-model-item label="标题">
            <a-input v-model="filterForm.title" style="width: 100%" allow-clear placeholder="缺陷标题/ID" class="form-model-item" @change="onTitleSearch" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="状态">
            <a-select v-model="filterForm.status" mode="multiple" style="width: 100%" allow-clear placeholder="状态" @change="onSearch">
              <a-select-option v-for="(item, index) in issueStatus" :key="index" :value="item.value">
                <a-tag :color="item.color">{{ item.label }}</a-tag>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item label="与我相关" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
            <a-radio-group v-model="filterForm.about" button-style="solid" @change="onSearch">
              <a-radio-button value="all"> 全部 </a-radio-button>
              <a-radio-button value="about"> 与我相关 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <span style="line-height: 38px">
            <a-popover placement="bottom" trigger="click">
              <template slot="title"> 更多筛选 <a-divider type="vertical" /> <a v-tc="{ name: '重置更多筛选' }" @click="onReset">重置</a> </template>
              <template slot="content">
                <a-form-model class="more-filter-form" style="width: 720px" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :model="filterForm">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-model-item label="优先级">
                        <a-select v-model="filterForm.priority" style="width: 100%" mode="multiple" allow-clear placeholder="优先级" @change="onSearch">
                          <a-select-option v-for="(item, index) in issuePrioritys" :key="index" :value="item.value">
                            <a-tag :color="item.color"> {{ item.label }} </a-tag>
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="等级">
                        <a-select v-model="filterForm.serious" mode="multiple" allow-clear placeholder="缺陷等级" @change="onSearch">
                          <a-select-option v-for="(item, index) in issueSerious" :key="index" :value="item.value">{{ item.label }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-model-item label="类型">
                        <a-select v-model="filterForm.issue_type" mode="multiple" allow-clear placeholder="缺陷类型" @change="onSearch">
                          <a-select-option v-for="(item, index) in issueTypes" :key="index" :value="item.value">{{ item.label }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="处理人">
                        <user-select v-model="filterForm.handler" mode="multiple" allow-clear show-search placeholder="处理人" :project-id="projectId" @change="onSearch" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-model-item label="责任人">
                        <user-select v-model="filterForm.maintainer" mode="multiple" allow-clear show-search placeholder="责任人" :project-id="projectId" @change="onSearch" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="验证人">
                        <user-select v-model="filterForm.verifier" mode="multiple" allow-clear show-search placeholder="验证人" :project-id="projectId" @change="onSearch" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-model-item label="创建人">
                        <user-select v-model="filterForm.creator" mode="multiple" allow-clear show-search placeholder="创建人" :project-id="projectId" @change="onSearch" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="发现阶段">
                        <a-select v-model="filterForm.stage" mode="multiple" allow-clear placeholder="发现阶段" @change="onSearch">
                          <a-select-option v-for="item in Object.values(issueStages).filter(value => value.status === true)" :key="item.value" :value="item.value">{{ item.label }} </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-model-item label="需求">
                        <a-select v-model="requirement" allow-clear show-search label-in-value style="width: 100%" :filter-option="false" :not-found-content="requirementSearching ? undefined : null" @search="searchRequirement" @change="onSearch">
                          <a-spin v-if="requirementSearching" slot="notFoundContent" size="small" />
                          <a-select-option v-for="item in searchRequirementData" :key="item.value" :value="item.value">
                            {{ item.label }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="迭代">
                        <a-select v-model="versionValue" allow-clear show-search label-in-value style="width: 100%" :filter-option="false" :not-found-content="versionSearching ? undefined : null" @search="searchVersion" @change="onSearch">
                          <a-spin v-if="versionSearching" slot="notFoundContent" size="small" />
                          <a-select-option v-for="item in searchVersionData" :key="item.value" :value="item.value">
                            {{ item.label }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-model-item label="系统/平台">
                        <a-select v-model="filterForm.system" allow-clear placeholder="系统/平台" @change="onSearch">
                          <a-select-option v-for="item in issueSystems" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="系统版本">
                        <a-input v-model="filterForm.system_version" allow-clear placeholder="系统/平台版本" class="form-model-item" @change="onSearch" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :span="24">
                      <a-form-model-item label="时间筛选" :label-col="{ span: 3 }">
                        <a-input-group compact>
                          <a-select v-model="filterForm.time_field" style="width: 30%" @change="onSearch">
                            <a-select-option value="created_time"> 创建时间 </a-select-option>
                            <a-select-option value="updated_time"> 更新时间 </a-select-option>
                          </a-select>
                          <a-date-picker v-model="filterForm.begin_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="onSearch" />
                          <a-date-picker v-model="filterForm.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="onSearch" />
                        </a-input-group>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
              </template>
              <a-badge :count="filterCount" :number-style="{ backgroundColor: '#448EF7' }">
                <a-button v-tc="{ name: '更多筛选' }" icon="filter">更多筛选</a-button>
              </a-badge>
            </a-popover>
            <a-button v-tc="{ name: '查询' }" type="primary" :style="{ margin: '0 8px' }" @click="onSearch">查询</a-button>
            <a-button v-tc="{ name: '重置' }" @click="onReset">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { storySearch } from '@/api/project/story';
import { projectList } from '@/api/project/project';
import { versionSearch } from '@/api/project/version';
import { issueStatus, issuePrioritys, issueTypes, issueSerious, issueSystems, issueFields, issueStages } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';

export default {
  components: { UserSelect },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: 'issue' // issue, work, version
    }
  },
  data() {
    return {
      issueTypes,
      issueStages,
      issueStatus,
      issueFields,
      issueSystems,
      issueSerious,
      issuePrioritys,
      filterForm: {},
      versionValue: {},
      requirement: {},
      searchVersionData: [],
      searchRequirementData: [],
      versionSearching: false,
      requirementSearching: false,
      projectId: parseInt(this.$route.params.project_id) || 0
    };
  },
  computed: {
    filterCount() {
      let count = 0;
      const ignoreKeys = ['title', 'status', 'about', 'time_field', 'page_size', 'page_number', 'project_id', 'fields'];
      for (const key of Object.keys(this.filterForm)) {
        const v = this.filterForm[key];
        if (key === 'about' && v === 'all') {
          continue;
        }
        if (ignoreKeys.includes(key) || !v || (Array.isArray(v) && v.length === 0)) continue;
        count++;
      }
      return count;
    }
  },
  watch: {
    value: {
      handler(val) {
        this.filterForm = val || {};
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /**
     * 获取项目列表
     */
    getProjectList() {
      projectList({ page_index: 1, page_size: 100 }).then(res => {
        this.versionData = res.data.projects;
      });
    },

    /**
     * 需求搜索
     * @param {*} value
     */
    searchRequirement(value) {
      const project_id = this.projectId === 0 ? null : this.projectId;
      storySearch({ project_id: project_id, value: value }).then(res => {
        this.searchRequirementData = res.data.items;
      });
    },

    /**
     * 迭代搜索
     * @param {*} value
     */
    searchVersion(value) {
      versionSearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchVersionData = res.data.items;
      });
    },

    /**
     * 点击重置
     */
    onReset() {
      this.filterForm = {};
      this.$emit('reset', this.filterForm);
    },

    /**
     * 搜索事件
     */
    onSearch() {
      this.filterForm = {
        ...this.filterForm,
        requirement_id: this.requirement && this.requirement.key ? this.requirement.key : null,
        version_id: this.versionValue && this.versionValue.key ? this.versionValue.key : null
      };
      this.$emit('change', this.filterForm);
      this.$emit('update:value', this.filterForm);
    },

    /**
     * 根据标题搜索，增加防抖机制
     */
    onTitleSearch: debounce(function () {
      this.onSearch();
    }, 500)
  }
};
</script>
<!-- <style lang="less" scoped>
/deep/.search-form .ant-form-item {
  display: inline-block !important;
}
/deep/ .ant-form-item {
  margin-bottom: 0px;
}
/deep/.more-filter-form .ant-form-item {
  margin-bottom: 2px;
}

/deep/.ant-form {
  margin: 4px 0px !important;
}

/deep/.more-filter-form .form-model-item {
  width: 100%;
}
.filter-btn {
  margin-top: 16px;
}
</style> -->

<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 2px;
}
/deep/.ant-form {
  margin: 4px 0px !important;
}

.form-model-item {
  width: 100%;
}
.filter-btn {
  margin-top: 18px;
}
</style>
